<template>
  <Popover>
    <template #button="{ open }">
      <HelpIcon :is-active="open" />
    </template>

    <template #header>
      <span class="flex items-center h-12">{{ helpNav.navHeading }}</span>
    </template>

    <template v-for="link in helpNav.links" :key="link.linkField[0].url">
      <MenuItem
        :as="LinkField"
        class="fluid-sm tracking-wider whitespace-nowrap block px-5 py-3 font-normal text-black no-underline transition-all hover:bg-putty border-2 border-white ui-active:border-br-green-dark"
        v-bind="link.linkField[0]"
      >
        <Icon v-if="link.icon" class="text-br-green inline-block w-5 h-5 mr-2 fill-current" :name="link.icon" />
        <span v-if="link.label">{{ $t(link.label) }}</span>
      </MenuItem>
    </template>
  </Popover>
</template>

<script setup>
import HelpIcon from '@/components/layout/header/HelpIcon.vue';
import Popover from '@/components/layout/header/Popover.vue';
import LinkField from '@/components/common/LinkField.vue';
import Icon from '@/components/icons/Icon.vue';
import { MenuItem } from '@headlessui/vue';
import { useMainNavStore } from '@/stores/main-nav';

const mainNavStore = useMainNavStore();

const helpNav = computed(() => mainNavStore.helpNav);
</script>
